<sim-basic-material-dialog
	(closeClicked)="close({action: 'close'})"
	[finished]="finished"
	[matDialogData]="data"
	[rect]="rect"
	[headerIcon]="{fontIcon: 'fa-cog', fontSet: 'fad'}"
	[headerText]="T.SETTINGS_STAGE_DESIGNER | translate"
	class="normalDuotoneHeaderIcon"
>
	<div class="settingsContent" dialogContent>
		@if (mobileNav) {
			<button (click)="mobileNavOpen = !mobileNavOpen" class="menuOpener" color="white" mat-icon-button>
				<sim-animated-material-icon
					[trigger]="mobileNavOpen"
					[endIcon]="{fontSet: 'fad', fontIcon: 'fa-times'}"
					[startIcon]="{
						fontSet: 'fad',
						fontIcon: 'fa-bars',
						themeColor: 'white',
					}"
				/>
			</button>
		}

		<div [class.mobileNav]="mobileNav" [class.open]="mobileNavOpen" class="leftNavPane">
			@for (settingsPage of settingPages; track settingsPage; let i1 = $index) {
				<div (click)="setActiveSettingsPage(i1)" [class.active]="i1 === activeSettingsPage" class="link" mat-ripple>
					<div class="top">
						<div class="activeSymbol"></div>
						<div class="icon">
							<i class="{{ settingsPage.icon }}"></i>
						</div>
						<div class="text">
							<h3 class="nopadding nomargin mat-h3">
								{{ settingsPage.title }}
							</h3>
						</div>
						@if (settingsPage.subCategories?.length > 0) {
							<div class="expandIcon">
								<button
									(click)="settingsPage.subCategoriesOpen = !settingsPage.subCategoriesOpen"
									appStopPropagation
									mat-icon-button
								>
									<sim-animated-material-icon
										[trigger]="settingsPage.subCategoriesOpen"
										[endIcon]="{
											fontSet: 'fad',
											fontIcon: 'fa-chevron-up',
											themeColor: 'white',
										}"
										[startIcon]="{
											fontSet: 'fad',
											fontIcon: 'fa-chevron-down',
											themeColor: 'accent',
										}"
									/>
								</button>
							</div>
						}
					</div>
					<div [class.open]="settingsPage.subCategoriesOpen" class="bottomLinks">
						@for (settingsSub of settingsPage.subCategories; track settingsSub; let isub = $index) {
							<div
								(click)="activeSettingsPageSub = isub"
								[class.active]="isub === activeSettingsPageSub && i1 === activeSettingsPage"
								[class.open]="settingsPage.subCategoriesOpen"
								appStopPropagation
								class="bottom"
								mat-ripple
							>
								<div class="icon">
									<i class="{{ settingsSub.icon }}"></i>
								</div>
								<div class="text">
									<h3 class="nopadding nomargin mat-h3">
										{{ settingsSub.title }}
									</h3>
								</div>
							</div>
						}
					</div>
				</div>
			}
		</div>

		<div (click)="mobileNavOpen = false" [class.showBackdrop]="mobileNavOpen" class="activePageContent">
			@if (mobileNav) {
				<div [class.active]="mobileNavOpen" class="backdrop"></div>
			}
			<ng-container class="h-100">
				@switch (activeSettingsPage) {
					@case (0) {
						<div [@zoomInOnEnter] class="h-100">
							<sim-settings-page-dashboard-configuration />
						</div>
					}
					@case (1) {
						<div [@zoomInOnEnter]>
							<sim-settings-page-stage-designer />
						</div>
					}
				}
			</ng-container>
		</div>
	</div>
</sim-basic-material-dialog>
